import { render, staticRenderFns } from "./ReferenceDetail.vue?vue&type=template&id=cc0a42e6&"
import script from "./ReferenceDetail.vue?vue&type=script&lang=js&"
export * from "./ReferenceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports